import { UserOutlined } from "@ant-design/icons";
import { Avatar } from "antd";
import { useContext } from "react";
import styles from "styles/components/profile.module.scss";
import ProfileContext from "components/profileContext";

const Profile = () => {
  const { profile } = useContext(ProfileContext);
  if (!profile || !profile.name) {
    return <></>;
  }
  return (
    <div className={styles.wrapper}>
      <Avatar
        src={profile.profilePicture}
        className={styles.avatar}
        icon={<UserOutlined />}
        size={26}
      />
      <div className={styles.name}>{profile.name}</div>
    </div>
  );
};

export default Profile;
